module.exports = __webpack_public_path__ + "img/kingofdice.7bd8dbe9.png";